import React from "react";
import { Modal, ModalBody } from "reactstrap";
import OpenSearch from "./OpenSearch";
import "./Style/SearchModal.scss";

// GlobalSearchModal Component defined
const GlobalSearchModal = ({ isOpen, toggle }) => {
  return (
    // Used Modal from reactstrap
    <Modal
      isOpen={isOpen}
      toggle={toggle}
      className={"search-modal primary-modal"}
    >
      <ModalBody>
        {/* Opensearch modal component called*/}
        <OpenSearch />
      </ModalBody>
    </Modal>
  );
};

export default GlobalSearchModal;
